import { render, staticRenderFns } from "./OttawaLab5ReportSheetPartBFr.vue?vue&type=template&id=17a1d119&"
import script from "./OttawaLab5ReportSheetPartBFr.vue?vue&type=script&lang=js&"
export * from "./OttawaLab5ReportSheetPartBFr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VSimpleTable,VTextField})
